@if (mode == 'mobile') {
  <div style="margin: 0 20px;">
    <div class="page-column">
      <app-logo class="spacing-top-bottom"/>
      <mat-divider class="primary"/>
      <div class="week-selection spacing-top">
        <app-icon-button (click)="changeDay(-1)" colorVariant="transparent" icon="keyboard_arrow_left" size="big"/>

        <div class="inner-column day-select" (click)="picker.open()">
          <div class="date-label body-text">
            {{ getFormatedDateLong() }}
            <mat-icon class="day-select-icon">calendar_today</mat-icon>
          </div>
          <input (dateChange)="onDaySelected($event)" [matDatepicker]="picker" [value]="currentDay" class="hidden-date-input"/>
          <mat-datepicker #picker/>
        </div>

        <app-icon-button (click)="changeDay(1)" colorVariant="transparent" icon="keyboard_arrow_right" size="big"/>
      </div>
      <div class="schedule-divider">
        <mat-icon class="color-800">wb_twilight</mat-icon>
        <div class="body-text-bold color-800">{{ 'courses.schedule.morning' | transloco }}</div>
        <mat-divider class="primary grow"/>
      </div>
      <div class="schedule-container">
        <div class="schedule-column">
          @for (app of activeSchedule?.morningAppointments; track app.id) {
            <div (click)="showBooking(app)" (mouseenter)="onHover(app)" (mouseleave)="onLeave()" [class.highlight]="app.isHighlighted" class="course-box">
              <div class="body-text-bold secondary trim">{{ app.title }}</div>
              <div class="body-text">{{ getStartDurationInfo(app) }}</div>
              <div class="body-text-small secondary trim">{{ app.therapist }}</div>
            </div>
          }
        </div>
      </div>
      <div class="schedule-divider">
        <mat-icon class="color-800">sunny</mat-icon>
        <div class="body-text-bold color-800">{{ 'courses.schedule.noon' | transloco }}</div>
        <mat-divider class="primary grow"/>
      </div>
      <div class="schedule-container">
        <div class="schedule-column">
          @for (app of activeSchedule?.dayAppointments; track app.id) {
            <div (click)="showBooking(app)" (mouseenter)="onHover(app)" (mouseleave)="onLeave()" [class.highlight]="app.isHighlighted" class="course-box">
              <div class="body-text-bold secondary trim">{{ app.title }}</div>
              <div class="body-text">{{ getStartDurationInfo(app) }}</div>
              <div class="body-text-small secondary trim">{{ app.therapist }}</div>
            </div>
          }
        </div>
      </div>
      <div class="schedule-divider">
        <mat-icon class="color-800">bedtime</mat-icon>
        <div class="body-text-bold color-800">{{ 'courses.schedule.evening' | transloco }}</div>
        <mat-divider class="primary grow"/>
      </div>
      <div class="schedule-container">
        <div class="schedule-column">
          @for (app of activeSchedule?.eveningAppointments; track app.id) {
            <div (click)="showBooking(app)" (mouseenter)="onHover(app)" (mouseleave)="onLeave()" [class.highlight]="app.isHighlighted" class="course-box">
              <div class="body-text-bold secondary trim">{{ app.title }}</div>
              <div class="body-text">{{ getStartDurationInfo(app) }}</div>
              <div class="body-text-small secondary trim">{{ app.therapist }}</div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
} @else {
  <div style="margin: 0 20px;">
    <div class="page-column">
      <app-logo class="spacing-top-bottom"/>
      <mat-divider class="primary"/>
      <div class="week-selection spacing-top">
        <app-icon-button (click)="changeWeek(-1)" colorVariant="transparent" icon="keyboard_arrow_left" size="big"/>

        <div class="inner-column">
          <div class="body-text-small-bold secondary">{{ "courses.schedule.timeRange" | transloco }}</div>
          <div class="body-text">{{ weekInfo }}</div>
        </div>

        <app-icon-button (click)="changeWeek(1)" colorVariant="transparent" icon="keyboard_arrow_right" size="big"/>
      </div>
      <div class="schedule-container spacing-top">
        @for (dto of allCourses; track dto.day) {
          <div class="schedule-column">
            <div class="schedule-headline body-text-small">{{ getFormatedDate(dto) }}</div>
          </div>
        }
      </div>
      <div class="schedule-divider">
        <mat-icon class="color-800">wb_twilight</mat-icon>
        <div class="body-text-bold color-800">{{ 'courses.schedule.morning' | transloco }}</div>
        <mat-divider class="primary grow"/>
      </div>
      <div class="schedule-container">
        @for (dto of allCourses; track dto.day) {
          <div class="schedule-column">
            @for (app of dto.morningAppointments; track app.id) {
              <div (click)="showBooking(app)" (mouseenter)="onHover(app)" (mouseleave)="onLeave()" [class.highlight]="app.isHighlighted" class="course-box">
                <div class="body-text-bold secondary trim">{{ app.title }}</div>
                <div class="body-text">{{ getStartDurationInfo(app) }}</div>
                <div class="body-text-small secondary trim">{{ app.therapist }}</div>
              </div>
            }
          </div>
        }
      </div>
      <div class="schedule-divider">
        <mat-icon class="color-800">sunny</mat-icon>
        <div class="body-text-bold color-800">{{ 'courses.schedule.noon' | transloco }}</div>
        <mat-divider class="primary grow"/>
      </div>
      <div class="schedule-container">
        @for (dto of allCourses; track dto.day) {
          <div class="schedule-column">
            @for (app of dto.dayAppointments; track app.id) {
              <div (click)="showBooking(app)" (mouseenter)="onHover(app)" (mouseleave)="onLeave()" [class.highlight]="app.isHighlighted" class="course-box">
                <div class="body-text-bold secondary trim">{{ app.title }}</div>
                <div class="body-text">{{ getStartDurationInfo(app) }}</div>
                <div class="body-text-small secondary trim">{{ app.therapist }}</div>
              </div>
            }
          </div>
        }
      </div>
      <div class="schedule-divider">
        <mat-icon class="color-800">bedtime</mat-icon>
        <div class="body-text-bold color-800">{{ 'courses.schedule.evening' | transloco }}</div>
        <mat-divider class="primary grow"/>
      </div>
      <div class="schedule-container">
        @for (dto of allCourses; track dto.day) {
          <div class="schedule-column">
            @for (app of dto.eveningAppointments; track app.id) {
              <div (click)="showBooking(app)" (mouseenter)="onHover(app)" (mouseleave)="onLeave()" [class.highlight]="app.isHighlighted" class="course-box">
                <div class="body-text-bold secondary trim">{{ app.title }}</div>
                <div class="body-text">{{ getStartDurationInfo(app) }}</div>
                <div class="body-text-small secondary trim">{{ app.therapist }}</div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
